import Vue from 'vue'
import Vuex from 'vuex'

import actionPlans from './modules/action-plans'
import groupFormModal from './modules/group-form-modal'
import classes from './modules/classes'
import teachers from "./modules/teachers";
import subjects from "./modules/subjects";
import user from "./modules/user";
import permissions from "./modules/permissions";
import modules from "./modules/modules";
import surveys from "./modules/surveys";
import poll from "./modules/poll";
import school from "./modules/school";
import invitationCampaigns from "./modules/invitation-campaigns";
import modals from "./modules/modals";
import execSummary from "./modules/executive-summary";
import benchmarks from "./modules/benchmarks";
import results from "./modules/results";
import organization from "./modules/organization";
import onboarding from "./modules/onboarding";
import surveyBuilder from "./modules/survey-builder";
import superadmin from "./modules/superadmin";
import freemium from "./modules/freemium";
import filters from "./modules/filters";

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
    },
    mutations: {
    },
    modules: {
        actionPlans,
        groupFormModal,
        classes,
        teachers,
        subjects,
        user,
        permissions,
        modules,
        surveys,
        poll,
        school,
        invitationCampaigns,
        modals,
        execSummary,
        benchmarks,
        results,
        organization,
        onboarding,
        surveyBuilder,
        superadmin,
        freemium,
        filters
    },
    strict: false,
})
